import * as Sentry from '@sentry/vue'
import store from '@/vuex/store'
import EventBus from '@/eventBus'

// CONSTANTS
const UPDATE_INPUT_EVENTS = {
  typeAnswer: 'on-generate-options',
  correctOrder: 'update-title-option',
}

const UPDATE_CANVAS_EVENTS = {
  matchPairs: 'match-pairs-change-v2',
  typeAnswer: 'eventShowQuizTypeAnswer',
  correctOrder: 'update-correct-order-canvas-content-v2',
}

// HELPERS
const reRenderRightColumnInput = () => {
  const eventName = UPDATE_INPUT_EVENTS[store.getters.currentSlideType]
  if (!eventName) return

  EventBus.$emit(eventName)
}

const reRenderCanvasContent = (options) => {
  const eventName = UPDATE_CANVAS_EVENTS[store.getters.currentSlideType]
  if (!eventName) return

  EventBus.$emit(eventName, options)
}

// MAIN_LOGIC
const onGenerateOptionsSuccess = (options) => {
  reRenderRightColumnInput()
  reRenderCanvasContent(options)
}

const onGenerateOptionsError = (error) => {
  Sentry.captureException(error)
}

const generateOptions = async (slideId) => {
  await store.dispatch('generateOptionsAction', {
    slideId,
    onGenerateOptionsSuccess,
    onGenerateOptionsError,
  })
}

export default {
  generateOptions,
}
